export default __webpack_public_path__ + "static/media/Light_05.821e3369.png";